import InstantWinSelect from "./instantWinSelect.container";

export default InstantWinSelect;
